function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var freeGlobal = require('./_freeGlobal');
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : _type_of(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;
